"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePatientSurveysCalculatedResults = exports.useIntakeSurveyMedicationAssessment = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _utils = require("../../utils");
var _types = require("../../types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var getLabel = _utils.GenderUtils.getLabel;
var usePatientSurveysCalculatedResults = function usePatientSurveysCalculatedResults(patient, prescreenerSurvey) {
  var _prescreenerSurvey$pa, _prescreenerSurvey$pa2;
  var _useRequest = (0, _utils.useRequest)((0, _utils.getSurveyResultUrl)((_prescreenerSurvey$pa = prescreenerSurvey.patientSurvey) === null || _prescreenerSurvey$pa === void 0 ? void 0 : _prescreenerSurvey$pa.id), {
      ready: !!((_prescreenerSurvey$pa2 = prescreenerSurvey.patientSurvey) !== null && _prescreenerSurvey$pa2 !== void 0 && _prescreenerSurvey$pa2.id)
    }),
    _useRequest$data = _useRequest.data,
    surveyResults = _useRequest$data === void 0 ? {} : _useRequest$data;
  return (0, _react.useMemo)(function () {
    var disorderValue = (0, _utils.getAUDSeverityDescriptor)(surveyResults.value);
    return {
      disorder: "".concat((0, _lodash.capitalize)(disorderValue), " risk, ").concat(surveyResults.value),
      historyOfIllness: "".concat((0, _utils.composeName)([patient.firstName, patient.lastName], ' '), " is a ").concat((0, _momentTimezone.default)().diff(patient.birthDate, 'years'), " year old ").concat(getLabel(patient.sex).toLowerCase(), " with a past medical history of ").concat(disorderValue, " alcohol use disorder who has completed a medical assessment.")
    };
  }, [patient, surveyResults]);
};

/**
 * Omit follow-up questions that are not necessary if answer was negative
 */
exports.usePatientSurveysCalculatedResults = usePatientSurveysCalculatedResults;
var useIntakeSurveyMedicationAssessment = function useIntakeSurveyMedicationAssessment(intakeSurveyData) {
  return (0, _react.useMemo)(function () {
    var _intakeSurveyData$pat, _intakeSurveyData$sur;
    var answers = (_intakeSurveyData$pat = intakeSurveyData.patientSurvey) === null || _intakeSurveyData$pat === void 0 ? void 0 : _intakeSurveyData$pat.patientAnswers;
    var questions = (_intakeSurveyData$sur = intakeSurveyData.survey) === null || _intakeSurveyData$sur === void 0 ? void 0 : _intakeSurveyData$sur.questions;
    if (!answers || !questions) {
      return {
        questions: null,
        specialAttentionItems: null
      };
    }
    var medicalQuestionNames = Object.values(_utils.MEDICAL_ASSESSMENT_QUESTION_NAMES);
    return answers.reduce(function (acc, answer, index, array) {
      var question = questions.find(function (_ref) {
        var id = _ref.id;
        return id === answer.questionId;
      });
      acc.questions.push(question);
      if (!medicalQuestionNames.includes(question.name)) {
        return acc;
      }

      // answers are ordered by question order
      var followUpOpenQuestionAnswer = array[index + 1];
      var followUpOpenQuestion = followUpOpenQuestionAnswer && questions.find(function (_ref2) {
        var id = _ref2.id;
        return id === followUpOpenQuestionAnswer.questionId;
      });
      var answerText = answer.answer[0];
      var isNegativeAnswer = ['No', 'None', 'I have not use any of the above substances', 'I have not used any of the above substances'].includes(answerText);
      if (question.name === _utils.WENT_3_DAYS_WITHOUT_DRINKING_QUESTION_NAME && isNegativeAnswer || question.name !== _utils.WENT_3_DAYS_WITHOUT_DRINKING_QUESTION_NAME && !isNegativeAnswer) {
        acc.specialAttentionItems.push( /*#__PURE__*/_react.default.createElement("div", {
          className: "ml-[16px]",
          key: answer.id
        }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
          className: "tw-body-medium"
        }, _utils.MEDICAL_ASSESSMENT_QUESTION_DESCRIPTIONS[question.name], ":", ' '), answerText !== _utils.YES_ANSWER && answer.answer.join(', ')), (followUpOpenQuestion === null || followUpOpenQuestion === void 0 ? void 0 : followUpOpenQuestion.type) === _types.SurveyQuestionTypesEnum.OPEN && /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
          className: "tw-body-medium"
        }, "More: "), followUpOpenQuestionAnswer.answer[0])));
      }
      return acc;
    }, {
      questions: [],
      specialAttentionItems: []
    });
  }, [intakeSurveyData.survey, intakeSurveyData.patientSurvey]);
};
exports.useIntakeSurveyMedicationAssessment = useIntakeSurveyMedicationAssessment;